import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'searchfilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: string, list:any[]): any[] {
        if (!items) return [];
        if (!value) return items;
        if(list) items = list;
        value = value.toString();
        return items.filter(item => item[field].toLowerCase().includes(value.toLowerCase()));
    }
}
